import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header, Title, Button } from "@/components";
import styles from "./NotFound.module.scss";
import { NotFoundPropsType } from "./types";
import notFoundImg from "@assets/icons/notFound.svg";

export const NotFound: React.FC<NotFoundPropsType> = ({ title }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Header title={title} />
      <main>
        <section className="container">
          <div className={styles.wrapper}>
            <div className={styles.image}>
              <img src={notFoundImg} alt="not found" />
            </div>

            <div className={styles.content}>
              <h2 className={styles.title}>
                Упс! Страница не найдена!
              </h2>
              <p className={styles.text}>
                Перейдите на главную страницу и попробуйте снова!
              </p>
            </div>
            
            <Button
              to="/"
              newStyles={styles.button}
            >
              Арендовать корт
            </Button>
          </div>
        </section>
      </main>
    </>
  );
};

